/* PR Studio locked page signup, two steps against the prstudio-drop-signup Worker.
   Step 1 posts { email }. That is a finished signup on its own: the shopper is on Klaviyo's
   "Email List" the moment it returns.
   Step 2 posts { email, phone, sms_consent: true } and only exists when the section's
   "Ask for a phone number after the email" setting is on. Phone field and submit start disabled
   in the markup and stay that way until the consent box is ticked.
   External file on purpose: the theme's PageSpeed packer sets later inline <script> tags to
   type="text/lazyload" on Linux browsers, so inline logic never runs at first paint. */
/* ---------------------------------------------------------------------------------------------
   The view ping. Shopify does not count this page: its `sessions` metric counts online store
   sessions and a password protected store's /password is not the online store, so the trekkie
   beacons fire and are filtered out downstream (179 Shopify sessions against 3,546 unique on
   Klaviyo's own onsite JS over the same 25 days). Without a view count the signup count is not a
   rate, so the Worker that already sees every signup counts the views too.

   One ping per browser session, after first paint, and it can never hold up the page: the id
   comes from sessionStorage inside a try/catch (a browser with storage blocked still counts, it
   just cannot be deduped), the request is fire and forget with keepalive, and every failure is
   swallowed. Nothing here is allowed to break the signup below it.
   --------------------------------------------------------------------------------------------- */
(function () {
  var root = document.querySelector('[data-prdrop-signup]');
  var endpoint = root && (root.getAttribute('data-endpoint') || '').trim();
  if (!endpoint) return;
  var view = endpoint.replace(/\/subscribe\/?$/, '') + '/view';
  var KEY = 'pr_lock_sid';
  var sid = '';
  var fresh = true;
  try {
    sid = sessionStorage.getItem(KEY) || '';
    if (sid) fresh = false;
    else { sid = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10); sessionStorage.setItem(KEY, sid); }
  } catch (e) { sid = ''; }
  /* A stored id that was already sent means this is a reload in the same tab: the Worker dedupes
     on the id anyway, so skipping the call here just saves the request. */
  if (!fresh && sid) return;
  function ping() {
    try {
      fetch(view, {
        method: 'POST', keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sid: sid }),
      }).catch(function () {});
    } catch (e) {}
  }
  function later() { if (window.requestIdleCallback) requestIdleCallback(ping, { timeout: 2000 }); else setTimeout(ping, 600); }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });
})();

(function () {
  var root = document.querySelector('[data-prdrop-signup]');
  if (!root || root.dataset.wired) return;
  root.dataset.wired = '1';

  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var source = root.getAttribute('data-source') || 'Season 9 locked page';
  var dial = (root.getAttribute('data-dial') || '+44').replace(/[^\d+]/g, '');
  var stepEmail = root.querySelector('[data-step="email"]');
  var stepSms = root.querySelector('[data-step="sms"]');
  var okBox = root.querySelector('[data-signup-ok]');
  var errBox = root.querySelector('[data-signup-err]');
  var emailInput = stepEmail && stepEmail.querySelector('input[name="email"]');
  var phoneInput = stepSms && stepSms.querySelector('input[name="phone"]');
  var consentBox = stepSms && stepSms.querySelector('input[name="sms_consent"]');
  var smsSubmit = stepSms && stepSms.querySelector('[type="submit"]');
  var skipBtn = stepSms && stepSms.querySelector('[data-sms-skip]');
  /* The shopper picks their own dialling code (David 2026-09-30). The select is the truth when it
     is there; data-dial stays the fallback for a theme that has no picker. Preselect their own
     country from Shopify.country, wrapped because Shopify is not guaranteed to exist.
     This sits BELOW stepSms on purpose. It used to stand above it, where var hoisting made stepSms
     undefined, so ccSelect was undefined on every page: the select was never preselected and
     gate() never enabled it, which left it dead at +44 however many times the shopper tapped it
     and put +44 in front of a number from anywhere else. Proved on live 2026-11-02 from an
     Indonesian market session. */
  var ccSelect = stepSms && stepSms.querySelector('[data-cc]');
  function currentDial() {
    if (ccSelect && ccSelect.value) return ccSelect.value.replace(/[^\d+]/g, '');
    return dial;
  }
  (function preselectCountry() {
    if (!ccSelect) return;
    var iso = '';
    try { iso = (window.Shopify && window.Shopify.country) || ''; } catch (e) { iso = ''; }
    if (!iso) return;
    var opts = ccSelect.options;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-iso') === iso) { ccSelect.selectedIndex = i; return; }
    }
  }());
  var emailValue = '';
  var page = root.closest ? root.closest('[data-prdrop]') : null;

  if (!endpoint) return; // no Worker URL set: leave the markup alone rather than eat the submit

  function show(el, on) {
    if (el) el.hidden = !on;
    if (el === stepSms && page) page.classList.toggle('is-step-sms', !!on);
  }
  function say(el, text) { if (!el) return; el.textContent = text || ''; el.hidden = !text; }
  function busy(form, on) {
    if (!form) return;
    form.classList.toggle('is-busy', !!on);
    var b = form.querySelector('[type="submit"]');
    if (b) b.disabled = !!on || (form === stepSms && consentBox && !consentBox.checked);
  }

  /* E.164 for Klaviyo. A typed "+" wins. "00" is the international prefix. Otherwise it is a
     national number and the section's default dialling code goes in front, after the trunk zero
     that UK and Korean numbers carry and Czech ones do not. */
  function e164(raw) {
    var v = String(raw || '').replace(/[^\d+]/g, '');
    if (v.charAt(0) === '+') return '+' + v.slice(1).replace(/\+/g, '');
    v = v.replace(/\+/g, '');
    if (v.slice(0, 2) === '00') return '+' + v.slice(2);
    var cd = currentDial(), cdd = cd.replace(/\D/g, '');
    /* "44 7700 900123" typed with GB +44 already picked: the code is in the number once, not twice.
       Only when the digits after it still make a whole national number, so a Czech 420 or a
       UK 44 at the start of a short local number is left alone. */
    if (cdd && v.indexOf(cdd) === 0 && v.length >= cdd.length + 9) return '+' + v;
    return cd + v.replace(/^0+/, '');
  }

  function post(body, form, done) {
    say(errBox, '');
    busy(form, true);
    fetch(endpoint, {
      method: 'POST',
      // text/plain keeps this a simple request, so there is no preflight on the happy path
      headers: { 'content-type': 'text/plain' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        busy(form, false);
        if (d && d.success) { done(); return; }
        say(errBox, (d && d.errors && d.errors[0]) || 'That did not go through. Try again in a moment.');
      })
      .catch(function () {
        busy(form, false);
        say(errBox, 'That did not go through. Check your connection and try again.');
      });
  }

  if (stepEmail) {
    stepEmail.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (emailInput && emailInput.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        say(errBox, 'That email does not look right. Check it and try again.');
        if (emailInput) emailInput.focus();
        return;
      }
      post({ email: v, source: source }, stepEmail, function () {
        emailValue = v;
        show(stepEmail, false);
        say(okBox, root.getAttribute('data-ok-email') || '');
        if (stepSms) {
          show(stepSms, true);
          if (consentBox) consentBox.focus();
        }
      });
    });
  }

  if (stepSms) {
    var gate = function () {
      var on = !!(consentBox && consentBox.checked);
      if (phoneInput) phoneInput.disabled = !on;
      if (ccSelect) ccSelect.disabled = !on;
      if (smsSubmit) smsSubmit.disabled = !on;
      if (on && phoneInput && !phoneInput.value) phoneInput.focus();
    };
    if (consentBox) consentBox.addEventListener('change', gate);
    gate();

    stepSms.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!consentBox || !consentBox.checked) { say(errBox, 'Tick the box to agree to texts first.'); return; }
      var num = e164(phoneInput && phoneInput.value);
      if (!/^\+[1-9]\d{7,14}$/.test(num)) {
        say(errBox, 'That number does not look right. Check it and try again.');
        if (phoneInput) phoneInput.focus();
        return;
      }
      post({ email: emailValue, phone: num, sms_consent: true, source: source + ' SMS' }, stepSms, function () {
        show(stepSms, false);
        say(okBox, root.getAttribute('data-ok-sms') || root.getAttribute('data-ok-email') || '');
      });
    });

    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        show(stepSms, false);
        say(errBox, '');
        say(okBox, root.getAttribute('data-ok-email') || '');
      });
    }
  }
})();
